import React from "react"
export function createMultipleRef(ref, quantity: number) {
  let refIndex = 0
  while (refIndex < quantity) {
    ref.current[refIndex] = React.createRef()
    refIndex++
  }
  return ref
}